export const locale___ComButtonShareComponent = {
	'open_in_nearby': {
		de_de: '______________________________',
		en_us: '______________________________',
		es_es: '______________________________',
		fr_fr: '______________________________',
		it_it: 'Apri in Nearby',
	},
	'share': {
		de_de: 'Teilen',
		en_us: 'Share',
		es_es: 'Compartir',
		fr_fr: 'Partager',
		it_it: 'Condividi',
	},
};